import { MarkStoryAsPublishedMeta, MarkStoryAsPublishedPayload } from 'types/store/MarkStoryAsPublished';
import { createAsyncReducer } from 'utils/Redux';

import { markStoryAsPublishedActions } from '../actions';

export default createAsyncReducer<MarkStoryAsPublishedMeta, MarkStoryAsPublishedPayload>(markStoryAsPublishedActions);
